import { QueryClientProvider } from '@tanstack/react-query'
import { AppRouter } from './router/AppRouter'
import { DataProvider } from './providers/DataProvider'
import { AuthProvider } from './providers/AuthProvider'
import { queryClient } from '../shared/api/queryClient'

export const SistemaSeguridadApp = () => {
    // ítem 15 Fase 1: React Query envuelve la app. La cache se purga en logout (AuthProvider).
    return (
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <DataProvider>
            <AppRouter />
          </DataProvider>
        </AuthProvider>
      </QueryClientProvider>
    );

};
